export default (props, vars) =>
  vars?.['usestatecurrentform']?.['state'] ===
  vars?.['useapplicationoffer2']?.['applicationOffer'].OFFER_LETTER_FORMS
    .ACCEPT;
